// extracted by mini-css-extract-plugin
export default {"subtitleHighlight":"Educators_subtitleHighlight__qXDeK","article":"Educators_article__N5YwS","contactInfo":"Educators_contactInfo__5OlbU","articles":"Educators_articles__leyKN"};